import { useEffect, useState } from "react";
import MiniDrawer from "../../component/Layout1";
import {
  Box,
  Grid,
  Table,
  TableContainer,
  TableHead,
  TableCell,
  TableRow,
  Typography,
  Stack,
  DialogActions,
  Button,
  Dialog,
  DialogContent,
  TableBody,
} from "@mui/material";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import CustomButon from "../../component/Button";
import CustomDialog from "../../component/dailog/dailog";

import { createQuotes, deleteDailyQuotes, getAllQuotes, updateDailyQuotes } from "../../api/auth";
import { Link } from "react-router-dom";

const Quotes = () => {
  const [dialog, setDialog] = useState(false);
  const [formValues, setFormValues] = useState({
    quotesDescription: "",
  });
  const [quotesData, setQuotesData] = useState([]);
  const [open, setOpen] = useState(false);
  const [selectedquoteId, setSelectedquoteId] = useState(null);

  const onSubmit = async () => {
    const resp = await createQuotes({ formValues });
    console.log("resp", resp);
    getAll()
  };

  const handleEdit = (quote) => {
    setFormValues({
      quotesDescription: quote.quotesDescription,
    });
    setSelectedquoteId(quote._id);
    setDialog(true);
  };

  const resetForm = () => {
    setFormValues({ quotesDescription: "" });
    setSelectedquoteId(null);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
  };


  const handleClose = () => {
    setOpen(false);
  };

  const handleClickOpen = (id) => {
    setSelectedquoteId(id);
    setOpen(true);
  };
  const handleDelete = async (id) => {
    const resp = await deleteDailyQuotes(id);
    if (resp.remote === "success") {
      setOpen(false);
    }
    getAll();
  };



  const getAll = async () => {
    const resp = await getAllQuotes();
    if (resp.remote === "success") {
      setQuotesData([...resp.data.quotes])
    }
  };

  const updateQuotes = async (id, formValues) => {
    try {
      const resp = await updateDailyQuotes({ id, formValues });
      if (resp.remote === "success") {
        getAll();
      }
    }
    catch (error) {
      console.log('error.........', error);
    }
  };

    useEffect(() => {
      getAll();
    }, [formValues]);

    return (
      <MiniDrawer>
        <Box>
          <Box
            sx={{
              margin: "10px 0",
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="h4" sx={{ fontSize: "30px", fontWeight: "500" }}>
              Quotes
            </Typography>
            <CustomButon onClick={() => setDialog(true)} variant="contained">
              Add
            </CustomButon>
          </Box>
          <Box className="FormBox" mb={2}>
            <TableContainer>
              <Table className="translation-table">
                <TableHead className="th">
                  <TableRow>
                    <TableCell>S.no.</TableCell>
                    <TableCell>Description</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {quotesData.map((el, index) => (
                    <TableRow key={el._id}>
                      <TableCell>{index + 1}</TableCell>
                      <TableCell>{el.quotesDescription}</TableCell>
                      <TableCell>
                        <Stack direction="row" alignItems="center" spacing={1}>
                          <Link
                            onClick={() => handleEdit(el)}
                            className="btnLink"
                            style={{ background: "#CFFFE2", padding: "5px", borderRadius: "5px" }}
                          >
                            <EditIcon style={{ color: "#00BE4C" }} />
                          </Link>

                          <Link
                            onClick={() => handleClickOpen(el._id)}

                            className="btnLink"
                            style={{ background: "#FFDCDC", padding: "5px", borderRadius: "5px" }}
                          >
                            <DeleteIcon style={{ color: "#FF0000" }} />
                          </Link>
                          <Dialog open={open} onClose={handleClose}>
                            <DialogContent>
                              <Typography
                                style={{
                                  fontWeight: 500,
                                  fontSize: "18.51px",
                                  lineHeight: "20.36px",
                                }}
                              >
                                Do you really want to remove the quote?
                              </Typography>
                            </DialogContent>
                            <DialogActions>
                              <Button onClick={handleClose} color="primary">
                                Cancel
                              </Button>
                              <Button
                                onClick={() => handleDelete(selectedquoteId)}
                                color="error"
                              >
                                Remove
                              </Button>
                            </DialogActions>
                          </Dialog>

                        </Stack>
                      </TableCell>
                    </TableRow>
                  ))
                  }
                </TableBody>
              </Table>
            </TableContainer>
            <Box className="FormBox" mb={3}>
              <CustomDialog
                open={dialog}
                onSave={() => {
                  if (selectedquoteId) {
                    updateQuotes(selectedquoteId, formValues);
                  } else {
                    onSubmit();
                  }
                  setDialog(false);
                  resetForm();
                  getAll()
                }}
                onClose={() => {
                  setDialog(false);
                  resetForm();
                }}
              >
                <form>
                  <Grid
                    container
                    spacing={2}
                    sx={{
                      "& input": {
                        width: "100%",
                        padding: "10px ",
                        borderRadius: "5px",
                      },
                    }}
                  >

                    <Grid item md={12}>
                      {" "}
                      <input
                        type="text"
                        placeholder="Quote message"
                        name="quotesDescription"
                        value={formValues.quotesDescription}
                        onChange={handleInputChange}
                      />
                    </Grid>
                  </Grid>
                </form>
              </CustomDialog>
            </Box>
          </Box>
        </Box>
      </MiniDrawer >
    );
  };

  export default Quotes;


